import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { keyframes, styled } from 'style'

const slideUpAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateY(2px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideRightAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateX(-2px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
})

const slideDownAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-2px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideLeftAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateX(2px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
})

export const ArrowStyled = styled(TooltipPrimitive.Arrow, {
  fill: '$bg1',
  stroke: '$bg3',
})

const TooltipContentStyled = styled(TooltipPrimitive.Content, {
  bgc: '$bg1',
  textAlign: 'center',
  color: '$text2',
  borderRadius: '$md',
  border: '1px solid $bg3',
  whiteSpace: 'nowrap',

  '@media (prefers-reduced-motion: no-preference)': {
    animationDuration: '400ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    willChange: 'transform, opacity',
    '&[data-state="delayed-open"]': {
      '&[data-side="top"]': { animationName: slideUpAndFade },
      '&[data-side="right"]': { animationName: slideRightAndFade },
      '&[data-side="bottom"]': { animationName: slideDownAndFade },
      '&[data-side="left"]': { animationName: slideLeftAndFade },
    },
  },

  variants: {
    type: {
      success: {
        borderColor: '$accent',
      },
      warning: {
        borderColor: '$warning',
      },
      error: {
        borderColor: '$error',
      },
    },
    size: {
      sm: {
        padding: '$0-5 $2 $1',
        fontSize: '$xs',
        fontHeight: '$xs',
        fontWeight: '$medium',
      },
      md: {
        padding: '$1-5 $3 $2',
        fontSize: '$sm',
        fontHeight: '$sm',
        fontWeight: '$medium',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export default TooltipContentStyled
